// extracted by mini-css-extract-plugin
export default {"clearButton":"styles_clearButton__wC6t+"};